import { FaCheck, FaQuestion } from 'react-icons/fa';
import { FaMagnifyingGlass } from 'react-icons/fa6';
import {
  ColumnsPieceServiceRenderer,
  PieceActionCell,
} from '../components/ColumnsPieceServiceRenderer';
import {
  ActionCell,
  ColumnsServiceRenderer,
} from '../components/ColumnsServiceRenderer';

export const StatusOptionsEnum = {
  PENDENTE: 4,
  ENCERRADO: 1,
  ENVIADO: 2,
  APROVADO: 3,
  APROVADO_PARCIALMENTE: 5,
  REPESCADO: 6,
  REPROVADO: 7,
  SERVIÇO_REALIZADO: 8,
  AGENDADO: 9,
};
export const OSStatusOptionEnum = {
  ABERTA: 1,
  FECHADA: 2,
  QUITADA: 3,
};

export const statusOptions = [
  {
    id: StatusOptionsEnum.PENDENTE,
    value: 'Pendente',
    label: 'Pendente',
    color: '#b36a22',
  },
  {
    id: StatusOptionsEnum.ENCERRADO,
    value: 'Encerrado',
    label: 'Encerrado',
    color: '#c95555',
  },
  {
    id: StatusOptionsEnum.ENVIADO,
    value: 'Enviado',
    label: 'Enviado',
    color: '#b5b5b5',
  },
  {
    id: StatusOptionsEnum.APROVADO,
    value: 'Aprovado',
    label: 'Aprovado',
    color: '#00A86B',
  },
  {
    id: StatusOptionsEnum.APROVADO_PARCIALMENTE,
    value: 'Aprovado Parcial',
    label: 'Aprovado Parcial',
    color: '#6eb6ff',
  },
  {
    id: StatusOptionsEnum.REPESCADO,
    value: 'Repescado',
    label: 'Repescado',
    color: '#eead2d',
  },
  {
    id: StatusOptionsEnum.REPROVADO,
    value: 'Reprovado',
    label: 'Reprovado',
    color: '#c95555',
  },
  {
    id: StatusOptionsEnum.SERVIÇO_REALIZADO,
    value: 'Serviço Realizado',
    label: 'Serviço Realizado',
    color: '#32CD32',
  },
  {
    id: StatusOptionsEnum.AGENDADO,
    value: 'Agendado',
    label: 'Agendado',
    color: '#4682B4',
  },
];

export const oSStatusOptions = [
  { id: OSStatusOptionEnum.ABERTA, value: 'Aberta', label: 'Aberta' },
  { id: OSStatusOptionEnum.FECHADA, value: 'Fechada', label: 'Fechada' },
  { id: OSStatusOptionEnum.QUITADA, value: 'Quitada', label: 'Quitada' },
];

export const columnsService = (onRemove, values, changeValue, budget) => [
  {
    id: 1,
    field: 'title',
    label: 'Serviço',
    width: '1fr',
    className: 'field-description',
    resizable: false,
    cellRenderer: ({ data }) => (
      <ColumnsServiceRenderer
        changeValue={changeValue}
        data={data}
        budget={budget}
      />
    ),
  },
  {
    id: 5,
    field: 'actions',
    label: 'Ações',
    resizable: false,
    width: '90px',
    cellRenderer: ({ data }) => <ActionCell data={data} onRemove={onRemove} />,
  },
];

export const sizeOptions = [
  { id: 2, value: 'P', label: 'P' },
  { id: 3, value: 'M', label: 'M' },
  { id: 4, value: 'G', label: 'G' },
];

// Converte o id numérico do tamanho (2/3/4) gravado no banco para o objeto
// { id, value, label } usado em todo o app. Fonte única de verdade (Orçamento e OS).
export const sizeIdToOption = (sizeId) => {
  if (!sizeId) return sizeOptions[1]; // default M
  return sizeOptions.find((o) => o.id === Number(sizeId)) || sizeOptions[1];
};

export const columnsPiece = (
  onRemove,
  changePartsValue,
  isOpen,
  setOpen,
  openEditModal
) => [
  {
    id: 1,
    field: 'name',
    label: 'Peça',
    width: '1fr',
    className: 'field-description',
    resizable: false,
    cellRenderer: ({ data }) => (
      <ColumnsPieceServiceRenderer
        data={data}
        changePartsValue={changePartsValue}
      />
    ),
  },
  {
    id: 5,
    field: 'actions',
    label: 'Ações',
    resizable: false,
    width: '90px',
    cellRenderer: ({ data }) => (
      <PieceActionCell
        data={data}
        onRemove={onRemove}
        isOpen={isOpen}
        setOpen={setOpen}
        openEditModal={openEditModal}
      />
    ),
  },
];

export const statusBadges = [
  { id: 3, value: <FaCheck />, label: 'Aprovado' },
  { id: 5, value: <FaMagnifyingGlass />, label: 'Analisando' },
  { id: 6, value: <FaQuestion />, label: 'Em dúvida' },
];
